import { render, staticRenderFns } from "./DateGraphWidget.vue?vue&type=template&id=36b4e6f0&scoped=true"
import script from "./DateGraphWidget.vue?vue&type=script&lang=js"
export * from "./DateGraphWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b4e6f0",
  null
  
)

export default component.exports